import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Toast } from "@egovernments/digit-ui-react-components";
import { Checkbox, FormControlLabel } from "@mui/material";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import useSubStep1Logic from "../hooks/useSubStep1Logic";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import {
  buildingInternalChanges,
  ConstructionTypeOptions,
  fullyPartial,
  natureOfCompounding,
  natureOfConstructionOptions,
  planOnOptions,
  projectTypeOptions,
  specialProjectOptions,
  yesOrNo,
  completionProjectTypes,
} from "../../../../TCPForms/data";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const SubStep1 = (props) => {
  const logic = useSubStep1Logic(props);
  const {
    t,
    handleSubmit,
    control,
    getValues,
    formData,
    handleSearchClick,
    handleDeclarationChange,
    declarationChecked,
    showToast,
    closeToast,
    riskType,
    watch,
    schemeType,
    fastPASData,
    dropDownData,
    isSelfCert,
    isCompounding,
    fullRows,
    remainingPlots,
    plotInputs,
    plotNumbers,
    handleTabChange,
    handleSubTabChange,
    id,
    user,
    setDeclarationChecked,
    // landUseList and landSubUseList are already calculated in the hook
    landUseList,
    landSubUseList,
    applicationFlow,
    DepartmentSelector,
    isCompletionValid,
    isLayoutCase,
    isPlinthApproved,
    isEmployee,
    pdfUrls,
  } = logic;

  // Watch all required fields
  const [
    watchProposalType,
    watchisSpecialProject,
    watchProjectType,
    watchPlotSubdivided,
    watchNeedComp,
    watchplotLeaseHold,
    watchNoOfPLots,
    watchPlanOn,
    watchnatureOfConstruction,
    watchbuildingClassification,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchSectorNo,
    watchLandMark,
    watchKhasraNo,
    watchTehsil,
    watchCompunding,
    watchInternalChanges,
    watchCompoundingDone,
    watchBuildingInternalChanges,
    watchApplicationNo,
  ] = watch([
    "proposalType",
    "isSpecialProject",
    "projectType",
    "plotSubdivided",
    "needCompounding",
    "plotLeaseHold",
    "noOfPlots",
    "planOn",
    "natureOfConstruction",
    "buildingClassification",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "sectorNo",
    "landMark",
    "khasraNo",
    "tehsil",
    "shortName",
    "internalChanges",
    "compoundingDone",
    "buildingInternalChanges",
    "prevFileNo",
  ]);

  const stateId = Digit.ULBService.getStateId();
  const userType = Digit.SessionStorage.get("userType");

  const { refetch } = Digit.Hooks.obps.useBPADetailsPage(
    stateId,
    {
      BPA: {
        applicationNo: id,
      },
    },
    {
      formType: "MAP_SUB",
      config: { enabled: false },
    }
  );

  const onSubmit = async (data) => {
    const finalPayload = {
      ...data,
      selfDrawingPdfId: pdfUrls.selfDrawingPdfId,
      approvalCertificateId: pdfUrls.approvalCertificateId,
    };

    handleSubTabChange(1, finalPayload);
    const res = await refetch();
  };

  console.log("formDatawww", formData);

  const Modal = useModal();
  useEffect(() => {
    if (watchInternalChanges == "yes" && watchCompoundingDone == "no") {
      Modal("Submission not allowed", `Please submit application for Compounding first`, "error");
    } else {
      return;
    }
  }, [watchCompoundingDone]);
  useEffect(() => {
    if (watchBuildingInternalChanges == "If contrary to the byelaws It has been extinguished") {
      Modal("Submission not allowed", `Please submit application for Compounding first`, "error");
    } else {
      return;
    }
  }, [watchBuildingInternalChanges]);

  if (applicationFlow !== null) {
    return <DepartmentSelector />;
  }

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          {watchPlanOn && (
            <div className="formHeaderContainer">
              <h4 className="formHeading" style={{ background: "#f2f2f2", textAlign: "end", fontSize: "20px", color: "green" }}>
                {t(`${riskType === "Others" ? "High Risk and High Nivesh" : riskType}`)}
              </h4>
            </div>
          )}
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS ID"
                  placeholder="Enter FASTPAS ID."
                  name="fastPASId"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.fastPASId}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("fastPASId"))}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Application Number")}
                  control={control}
                  placeholder={t("Enter File No")}
                  name="prevFileNo"
                  mandatory
                  // maxLength={15}
                  defaultValue={formData?.prevFileNo}
                  type="textInput"
                  disabled={userType !== "citizen"}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Previous Sanction date")}
                  control={control}
                  placeholder={t("Enter Previous Sanction date")}
                  name="layoutsanctionDate"
                  // defaultValue={formData?.sanctionValidityStartDate}
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Previous Sanction Validity date")}
                  control={control}
                  placeholder={t("Enter Previous Sanction Validity date")}
                  name="validityDate"
                  // defaultValue={formData?.sanctionValidityDate}
                  defaultValue={formData?.validityDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Permit No.")}
                  control={control}
                  placeholder={t("Enter Permit No.")}
                  name="permitNumber"
                  defaultValue={formData?.permitNumber}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
              <Col></Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Completion/Occupancy Certificate required")}`}
                  name="occupancyCertificate"
                  defaultValue={formData?.occupancyCertificate}
                  type="radioButton"
                  mandatory
                  data={fullyPartial}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>

              {!isLayoutCase ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Is any internal changes (except exempted from building permit) done from the approved plan?")}`}
                    name="internalChanges"
                    defaultValue={formData?.internalChanges}
                    type="radioButton"
                    mandatory
                    data={yesOrNo}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={userType !== "citizen"}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            {watchInternalChanges == "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Is Compounding Done?")}`}
                    name="compoundingDone"
                    defaultValue={formData?.compoundingDone}
                    type="radioButton"
                    mandatory
                    data={yesOrNo}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            {watchInternalChanges === "yes" && watchCompoundingDone == "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Compounding map sanction number")}
                    control={control}
                    placeholder={t("Enter sanction number")}
                    name="compoundingNumber"
                    mandatory
                    maxLength={23}
                    defaultValue={formData?.compoundingNumber}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    showSearchIcon={true}
                    // onSearchClick={() => handlePrevFileSearch(getValues("prevFileNo"))}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Compounding map sanction date")}
                    control={control}
                    placeholder={t("Enter Compounding map sanction date")}
                    name="compoundingSanctionDate"
                    defaultValue={formData?.compoundingSanctionDate}
                    // defaultValue={formData?.layoutsanctionDate}
                    type="datePicker"
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t(isLayoutCase ? "Internal changes in layout/map" : "Internal changes in the building")}
                  name="buildingInternalChanges"
                  placeholder={t("Select Options")}
                  defaultValue={formData?.buildingInternalChanges}
                  type="selectInput"
                  mandatory
                  data={buildingInternalChanges}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
              {watchInternalChanges === "yes" && watchCompoundingDone == "yes" ? (
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    label={t("Permit no. for compounding")}
                    name="compoundingPermitNo"
                    defaultValue={formData?.compoundingPermitNo}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchlandUseType}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout || formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={(schemeType && watchSubZoneType) || userType !== "citizen"}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPrimaryUse}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchAtivityProposed}
                />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(planOnOptions)}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="planOn"
                  defaultValue={formData?.planOn}
                  type="selectInput"
                  mandatory={schemeType}
                  validation={{
                    required: {
                      value: schemeType,
                      message: "This field is required",
                    },
                  }}
                  disabled={!schemeType}
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={"Other Proposed Site"}
                    control={control}
                    placeholder={t("Enter Proposed Site")}
                    name="otherSchemeName"
                    mandatory
                    defaultValue={formData?.otherSchemeName}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row> */}

            {/* <Row>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction No.")}
                  control={control}
                  placeholder={t("Enter layout sanction number")}
                  name="layoutsanctionNumber"
                  defaultValue={formData?.layoutsanctionNumber}
                  type="textInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction Date")}
                  control={control}
                  placeholder={t("Enter Layout Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                />
              </Col>
            </Row> */}
            <Row>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={t("Development Area")}
                    control={control}
                    placeholder={t("Select Development Area Type")}
                    data={SortingAlphabatically(ConstructionTypeOptions)}
                    name="constructionType"
                    mandatory
                    defaultValue={formData?.constructionType}
                    type="selectInput"
                    disabled={userType !== "citizen"}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              <Col></Col>
            </Row>
            {/* <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(natureOfConstructionOptions)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isSelfCert}
                />
              </Col>
              {watchnatureOfConstruction && watchnatureOfConstruction !== "New" && watchnatureOfConstruction !== "Compounding" ? (
                <Col>
                  <InputWrapper
                    label={t("Prev File No")}
                    control={control}
                    placeholder={t("Enter File No")}
                    name="prevFileNo"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.prevFileNo}
                    type="textInput"
                  />
                </Col>
              ) : watchnatureOfConstruction === "Compounding" ? (
                <Col>
                  <InputWrapper
                    label={t("DM Circle Rate (In Rs. Per Square meter)")}
                    control={control}
                    placeholder={t("Enter DM Rate")}
                    name="dmCircleRate"
                    mandatory
                    containerStyles={{ lineHeight: "11px" }}
                    customLabelStyles={{ lineHeight: "11px" }}
                    defaultValue={formData?.dmCircleRate}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row> */}
            <Row>
              <Col>
                {schemeType && (
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="selectInput"
                    mandatory
                    data={SortingAlphabatically(dropDownData?.schemeName)}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={fastPASData?.descriptionOfLand?.schemeName}
                  />
                )}
              </Col>

              <Col>
                {" "}
                <InputWrapper
                  label={t("Tehsil")}
                  control={control}
                  placeholder={t("Enter Tehsil")}
                  name="tehsil"
                  defaultValue={formData?.tehsil}
                  type="textInput"
                  disabled={formData?.tehsil}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                  mandatory={!schemeType}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Revenue Village/Colony Name"
                  control={control}
                  placeholder="Enter Revenue Village"
                  defaultValue={formData?.descriptionOfLand?.khasraDetails?.[0]?.tehsil}
                  name={`revenueVillage`}
                  type="textInput"
                  mandatory={!schemeType}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                  disabled={formData?.landMark}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {schemeType && (
                  <InputWrapper
                    label={t("Sector/Pocket No.")}
                    control={control}
                    placeholder={t("Enter Sector/Pocket No.")}
                    name="sectorNo"
                    mandatory={!schemeType}
                    maxLength={15}
                    defaultValue={formData?.sectorNo}
                    type="textInput"
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
              <Col>
                <InputWrapper
                  label={t("Khasra No.")}
                  control={control}
                  placeholder={t("Enter Khasra No.")}
                  name="khasraNo"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.khasraNo}
                  type="textInput"
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
            </Row>

            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Standard Type Design")}`}
                  name="proposalType"
                  defaultValue={formData?.proposalType}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col> */}
              {schemeType ? (
                <Col>
                  <InputWrapper
                    label={t("Plot No")}
                    control={control}
                    placeholder={t("Enter Plot no")}
                    name="plotNo"
                    mandatory
                    defaultValue={formData?.plotNo || fastPASData?.descriptionOfLand?.plotNo}
                    type="textInput"
                    disabled={fastPASData?.descriptionOfLand?.plotNo || formData?.plotNo}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              <Col></Col>
            </Row>
            <Row>
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction date of layout")}
                    control={control}
                    placeholder={t("Enter Sanction date Of layout")}
                    name="sanctionDate"
                    mandatory
                    defaultValue={formData?.sanctionDate}
                    type="datePicker"
                  />
                </Col>
              )}
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction number of layout")}
                    control={control}
                    placeholder={t("Enter Sanction number Of layout")}
                    name="sanctionNumber"
                    mandatory
                    defaultValue={formData?.sanctionNumber}
                    type="textInput"
                  />
                </Col>
              )}
            </Row>
            {/* No Of Plots mapping  */}
            {watchProposalType === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("No. Of Plots")}
                    control={control}
                    placeholder={t("Enter No. Of Plots")}
                    name="noOfPlots"
                    mandatory
                    defaultValue={formData?.noOfPlots}
                    type="textInput"
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            {watchProposalType === "yes" && (
              <React.Fragment>
                {/* Full rows */}
                {Array.from({ length: fullRows }).map((_, rowIndex) => (
                  <Row key={rowIndex}>
                    {Array.from({ length: 3 }).map((_, colIndex) => {
                      const plotIndex = rowIndex * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            hasLabel={false}
                            maxLength={15}
                            defaultValue={formData?.plotNumbers?.[plotIndex] || ""}
                            type="textInput"
                          />
                        </Col>
                      );
                    })}
                  </Row>
                ))}

                {/* Remaining plots */}
                {remainingPlots > 0 && (
                  <Row key={fullRows}>
                    {Array.from({ length: remainingPlots }).map((_, colIndex) => {
                      const plotIndex = fullRows * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            maxLength={15}
                            hasLabel={false}
                            defaultValue={formData?.plotNumbers?.[plotIndex] || ""}
                            type="textInput"
                          />
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </React.Fragment>
            )}

            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  data={completionProjectTypes}
                  label={`${t("Project Type")}`}
                  placeholder={"Select Project Type"}
                  name="buildingClassification"
                  defaultValue={formData?.buildingClassification}
                  type={"selectInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  // disabled={!!watchPlanOn}
                />
              </Col> */}
              <Col>
                {watchbuildingClassification === "Others" && (
                  <Col>
                    <InputWrapper
                      label={t("Other Project")}
                      control={control}
                      placeholder={t("Enter  Name")}
                      name="otherbuildingClass"
                      mandatory
                      isRequired={true}
                      defaultValue={formData?.otherbuildingClass}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                )}
              </Col>
            </Row>

            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Special Project type")}`}
                  name="isSpecialProject"
                  defaultValue={formData?.isSpecialProject}
                  type="radioButton"
                  data={yesOrNo}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col> */}
              {/* <Col>
                {" "}
                {(watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && (
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={t("If Community Parking Provided")}
                    placeholder={t("Select Community Parking")}
                    name="communityParking"
                    defaultValue={formData?.communityParking}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col> */}
            </Row>
            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Special Condition of Project")}
                    control={control}
                    placeholder={t("Select Condition of Project")}
                    data={SortingAlphabatically(specialProjectOptions)}
                    name="projectType"
                    mandatory
                    defaultValue={formData?.projectType}
                    type="selectInput"
                  />
                </Col>
                <Col>
                  {watchProjectType === "Other" && (
                    <Col>
                      <InputWrapper
                        label={t("Other Project")}
                        control={control}
                        placeholder={t("Enter  Name")}
                        name="otherProjectName"
                        mandatory
                        defaultValue={formData?.otherProjectName}
                        type="textInput"
                      />
                    </Col>
                  )}
                </Col>
              </Row>
            )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Ground Coverage")}
                      placeholder={t("Enter Ground Coverage")}
                      name="groundCoverages"
                      defaultValue={formData?.groundCoverages || formData?.groundCoverage}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>

                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("FAR")}
                      placeholder={t("Enter FAR")}
                      name="fars"
                      defaultValue={formData?.fars || formData?.far}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Building Height")}
                      placeholder={t("Enter Building Height")}
                      name="buildingHeight"
                      defaultValue={formData?.buildingHeight}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Please specify if any other condition")}
                      placeholder={t("Enter condition")}
                      name="anyotherCondition"
                      defaultValue={formData?.anyotherCondition}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Front")}
                      control={control}
                      placeholder={t("Enter Front")}
                      name="previousSetbackFront"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackFront || formData?.setbackFronts}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Rear")}
                      control={control}
                      placeholder={t("Enter Rear")}
                      name="previousSetbackRear"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackRear || formData?.setbackRears}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Side Setback-1")}
                      control={control}
                      placeholder={t("Enter Side Setback-1")}
                      name="previousSetbackSide1"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide1 || formData?.setbackSide1}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Side Setback-2")}
                      control={control}
                      placeholder={t("Enter Side Setback-2")}
                      name="previousSetbackSide2"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide2 || formData?.setbackSide2}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}
            {fastPASData && fastPASData?.descriptionOfLand?.landArea < 40000 && watchlandUseType !== "Residential" && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={`${t("Will You Pay Shelter Fee")}`}
                    name="shelterFee"
                    defaultValue={formData?.shelterFee}
                    type="radioButton"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            <Row>
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (
                <Col>
                  <InputWrapper
                    label={t("Is Your Plot sub-division")}
                    control={control}
                    name="plotSubdivided"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.plotSubdivided}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row>
            <Row>
              {watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Does existing building require any compounding ?")}
                    control={control}
                    name="needCompounding"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.needCompounding}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row>
            <Row>
              {watchNeedComp === "no" && watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Is your plot Lease hold ?")}
                    control={control}
                    name="plotLeaseHold"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.plotLeaseHold}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row>
            {/* <Row>
              <Col>
                <InputWrapper
                  label={t("Do you want Purchasable FAR?")}
                  control={control}
                  name="plotLeaseHold"
                  mandatory
                  data={yesOrNo}
                  defaultValue={formData?.plotLeaseHold}
                  type="radioButton"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                {watchplotLeaseHold === "yes" && (
                  <InputWrapper
                    label={t("Basic FAR")}
                    control={control}
                    name="basicFAR"
                    mandatory
                    placeholder={t("Enter Basic FAR")}
                    defaultValue={formData?.basicFAR}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
            </Row> */}
            {watchplotLeaseHold === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Purchasable FAR")}
                    control={control}
                    name="purchasableFAR"
                    mandatory
                    defaultValue={formData?.purchasableFAR}
                    type="textInput"
                    placeholder={t("Enter Purchasable FAR")}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Premium FAR")}
                    control={control}
                    name="premiumFAR"
                    mandatory
                    defaultValue={formData?.premiumFAR}
                    type="textInput"
                    placeholder={t("Enter Premium FAR")}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}
            {watchnatureOfConstruction === "Compounding" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Is building plan previously approved?")}
                    control={control}
                    name="shortName"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.shortName}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                {watchCompunding !== "no" && <Col></Col>}
                {watchCompunding === "no" && (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Nature of compounding")}
                      placeholder={t("Select Nature Of Compounding")}
                      name="isAncestralProperty"
                      defaultValue={formData?.isAncestralProperty}
                      data={SortingAlphabatically(natureOfCompounding)}
                      type="selectInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      // disabled={isSelfCert}
                    />
                  </Col>
                )}
              </Row>
            )}
            {isPlinthApproved && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Plinth application Number")}
                    control={control}
                    placeholder={t("Enter File No")}
                    name="plinthApplicationNo"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.plinthApplicationNo}
                    type="textInput"
                  />
                </Col>
              </Row>
            )}
            {/* <div className="formContainer bg-white">
              <FormControlLabel
                style={{ padding: "10px 15px" }}
                control={
                  <Checkbox
                    name="declaration"
                    control={control}
                    onChange={handleDeclarationChange}
                    rules={{ required: "You must agree to the terms and conditions" }}
                  />
                }
                label={
                  <span>
                    I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.
                    <br /> The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information
                    present in the file shall not be the responsibility of the EDCR Engine.
                  </span>
                }
              />
            </div> */}
          </Container>
        </div>
        <div className="footerContainer">
          {userType !== "employee" && (
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3" }}
                disabled={
                  watchPlotSubdivided === "yes" ||
                  watchNeedComp === "yes" ||
                  (watchInternalChanges === "yes" && watchCompoundingDone == "no") ||
                  watchBuildingInternalChanges == "If contrary to the byelaws It has been extinguished" ||
                  !isCompletionValid
                }
              />
            </div>
          )}
        </div>
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
